// src/utils/scrollPosition.js
export default {
  // 收集当前页面的滚动位置
  collect() {
    const scrollPosition = {
      // 保存窗口滚动位置
      window: {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop
      },
      // 保存常见可滚动元素的位置
      elements: this.collectElements()
    }

    return scrollPosition
  },

  // 收集可滚动元素的位置
  collectElements() {
    const positions = {}

    // 常见的可滚动元素选择器
    const selectors = [
      '.el-table__body-wrapper',    // Element UI 表格
      '.self-table',                // 你的表格类名
      '.content-wrapper',
      '.main-container',
      '.el-scrollbar__wrap'
    ]

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector)
      elements.forEach((el, index) => {
        if (el && (el.scrollTop !== 0 || el.scrollLeft !== 0)) {
          const key = `${selector.replace(/[.\s]/g, '_')}_${index}`
          positions[key] = {
            selector: selector,
            index: index,
            scrollTop: el.scrollTop,
            scrollLeft: el.scrollLeft
          }
        }
      })
    })

    return positions
  },

  // 恢复滚动位置
  restore(scrollPosition) {
    if (!scrollPosition) return

    // 恢复窗口滚动位置
    if (scrollPosition.window) {
      setTimeout(() => {
        window.scrollTo(
          scrollPosition.window.x || 0,
          scrollPosition.window.y || 0
        )
      }, 100)
    }

    // 恢复元素滚动位置
    if (scrollPosition.elements) {
      setTimeout(() => {
        Object.keys(scrollPosition.elements).forEach(key => {
          const pos = scrollPosition.elements[key]
          if (pos.selector && pos.index !== undefined) {
            const elements = document.querySelectorAll(pos.selector)
            if (elements[pos.index]) {
              elements[pos.index].scrollTop = pos.scrollTop || 0
              elements[pos.index].scrollLeft = pos.scrollLeft || 0
            }
          }
        })
      }, 100)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/scrollPosition.js